import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { forgotPassword } from '../actions/auth';
import arrowLeft from '../assets/arrow-left.svg';
import { ACTIONS } from '../constants/auth';
import ForgotPasswordForm from '../components/forgot-password/forgot-password-form';

const ForgotPasswordPage = (_, context) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onSubmitHandler = (data) => {
    dispatch(forgotPassword(data.email, history));
  };

  const { loggedIn } = useSelector((state) => state.auth);

  useEffect(() => {
    if (loggedIn) {
      history.push('/details');
      dispatch({ type: ACTIONS.LOGIN_FAILURE, payload: null });
    }

    return () => {
      dispatch({ type: ACTIONS.FORGOT_PASSWORD_FAILURE });
    };
  }, [loggedIn, history, dispatch]);

  return (
    <div className="col p-0 m-0">
      <div className="container my-5">
        <h3 className="font-weight-bold text-center">{context.t('APP.RESET-PASSWORD.TITLE')}</h3>
        <h6 className="text-center mb-5">{context.t('APP.RESET-PASSWORD.DESC')}</h6>

        <ForgotPasswordForm onSubmit={onSubmitHandler} />
      </div>

      <div className="d-none d-sm-block space-5" />

      <div className="row">
        <div className="col-md border py-5 d-flex flex-column align-items-center justify-content-center">
          <div className="d-none d-sm-block space-5" />

          <h1 className=" font-weight-bold text-center w-75 m-0">
            {context.t('APP.FOOTER.MIOO_SAFETY_TITLE_1')}
          </h1>

          <h4 className="text-center pt-5">
            <a href={context.t('APP.FOOTER.MIOO_SAFETY_LINK_1')} className="text-dark">
              {context.t('APP.FOOTER.MIOO_SAFETY_DESC_1')}
              <img src={arrowLeft} alt="→" />
            </a>
          </h4>

          <div className="d-none d-sm-block space-5" />
        </div>

        <div className="col-md border py-5 d-flex flex-column align-items-center justify-content-center">
          <div className="d-none d-sm-block space-5" />

          <h1 className=" font-weight-bold text-center w-75 m-0">
            {context.t('APP.FOOTER.MIOO_SAFETY_TITLE_2')}
          </h1>

          <div className="d-none d-sm-block space-5" />
        </div>
      </div>
    </div>
  );
};

ForgotPasswordPage.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default ForgotPasswordPage;
